"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var wf_bulk_action_popup_model_1 = require("../portfolio/wf-bulk-action-popup.model");
var WfActionProgressDialog = /** @class */ (function () {
    function WfActionProgressDialog(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._progressValue = 0;
        this.closeButtonDisabled = true;
        this.movedItems = 0;
        this.failedItems = 0;
        dialogRef.disableClose = true;
    }
    Object.defineProperty(WfActionProgressDialog.prototype, "progressValue", {
        get: function () {
            var _this = this;
            if (this.data.totalCount == this.data.movedItems + this.data.failedItems) {
                setTimeout(function () {
                    _this.movedItems = _this.data.movedItems;
                    _this.failedItems = _this.data.failedItems;
                    _this._progressValue = (_this.data.movedItems + _this.data.failedItems) / _this.data.totalCount * 100;
                    _this.closeButtonDisabled = false;
                }, 2000);
            }
            else {
                this.movedItems = this.data.movedItems;
                this.failedItems = this.data.failedItems;
                this._progressValue = (this.data.movedItems + this.data.failedItems) / this.data.totalCount * 100;
            }
            return this._progressValue;
        },
        set: function (value) {
            this._progressValue = value;
        },
        enumerable: true,
        configurable: true
    });
    WfActionProgressDialog.prototype.onCloseClick = function () {
        this.dialogRef.close();
    };
    WfActionProgressDialog.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-wf-action-progress-dialog',
                    template: "\n\t\t\t\t<h1 mat-dialog-title>{{'portfolio.bulking.action.message' | sisTranslateMessage | async}}</h1>\n\t\t\t\t{{data.totalCount}}/{{movedItems+data.failedItems}}\n\t\t\t\t<section>\n\t\t\t\t\t<mat-progress-bar\n\t\t\t\t\t\t\t[color]='\"primary\"'\n\t\t\t\t\t\t\t[mode]='\"determinate\"'\n\t\t\t\t\t\t\t[value]=progressValue\n\t\t\t\t\t\t\t[bufferValue]='0'>\n\t\t\t\t\t</mat-progress-bar>\n\t\t\t\t</section>\n\t\t\t\t<br/>\n\t\t\t\t<div mat-dialog-content>\n\t\t\t\t\t<div fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n\t\t\t\t\t\t<span fxFlex=\"75\">{{'portfolio.bulking.action.processed.items.message' | sisTranslateMessage | async}}:</span> \n\t\t\t\t\t\t<span fxFlex=\"25\" fxLayoutAlign=\"start center\"> {{movedItems+failedItems}}</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n\t\t\t\t\t\t<span fxFlex=\"75\">{{'portfolio.bulking.action.items.moved.message' | sisTranslateMessage | async}}:</span>\n\t\t\t\t\t\t<span fxFlex=\"25\" fxLayoutAlign=\"start center\">{{movedItems}}</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n\t\t\t\t\t\t<span fxFlex=\"75\">{{'portfolio.bulking.action.items.failed.move.message' | sisTranslateMessage | async}}:</span>\n\t\t\t\t\t\t<span fxFlex=\"25\" fxLayoutAlign=\"start center\">{{failedItems}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div mat-dialog-actions>\n\t\t\t\t\t<button mat-raised-button [disabled]=\"data.totalCount!=data.movedItems+data.failedItems\" (click)=\"onCloseClick()\">{{'portfolio.bulking.action.dialog.close.message' | sisTranslateMessage | async}}</button>\n\t\t\t\t</div>\n\t"
                },] },
    ];
    /** @nocollapse */
    WfActionProgressDialog.ctorParameters = function () { return [
        { type: material_1.MatDialogRef, },
        { type: wf_bulk_action_popup_model_1.WfBulkActionPopupModel, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
    ]; };
    return WfActionProgressDialog;
}());
exports.WfActionProgressDialog = WfActionProgressDialog;
//# sourceMappingURL=wf-action-progress-dialog.component.js.map